module.exports = __webpack_public_path__ + "img/logo.44d01ef1.png";